import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import { useTranslation } from 'react-i18next';

function Header({ title, printPicture }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleCompetencesClick = (e) => {
    e.preventDefault();
    
    if (window.location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        const section = document.getElementById("competences");
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // Petit délai pour s'assurer que la page a rechargé
    } else {
      const section = document.getElementById("competences");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header>
      <div className="header">
        <Link to="/"><img src="/logo_BJ/Unknown-1.png" alt="logo" id="logo" /></Link>

        <div className="header-links">
          <Link to="/projets">{t('header.projects')}</Link>
          <Link to="/experiences">{t('header.experiences')}</Link>
          <Link to="/" onClick={handleCompetencesClick}>
            {t('header.skills')}
          </Link>
          <select onChange={e => changeLanguage(e.target.value)} value={i18n.language} className="lang-select">
            <option value="fr">fr</option>
            <option value="en">en</option>
          </select>
        </div>
      </div>
      {!printPicture ? (
        <div>
          <div className="container">
            <img src="/assets/background_title-line.png" alt="background" className="background_title" />
            <div className="text-overlay">
              <h1>{t('header.brandName')}</h1>
              <h2>{title}</h2>
            </div>
          </div>
          <img src='/assets/white-line.png' alt='background' className='white-line'/>
        </div>
      ) : (
        <div>
          <img src="/assets/black-line.png" alt="" className="black-line" />
        </div>
      )}
    </header>
  );
}

export default Header;